var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "report-page content-500" },
        [
          _c("h2", { staticClass: "page-title" }, [_vm._v("Sync Status")]),
          _vm._v(" "),
          _c("p", { staticClass: "text-xs-center" }, [
            _c("em", [
              _vm._v(
                "The reports below have not been properly synced to the server."
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-xs-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn__sync_all",
                  attrs: { disabled: !_vm.items.length, color: "success" },
                  on: {
                    click: function($event) {
                      return _vm.$syncService.sync()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [_vm._v("sync")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "btn__text" }, [_vm._v("Sync All")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list",
            { attrs: { "two-line": "" } },
            [
              _vm._l(_vm.items, function(item, index) {
                return [
                  _c(
                    "v-list-tile",
                    { key: index, staticClass: "field px-0" },
                    [
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [
                            _vm._v(_vm._s(item.room_id))
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-sub-title",
                            { staticClass: "grey--text text--darken-4" },
                            [
                              _vm._v(
                                "Last attempted at " +
                                  _vm._s(_vm._f("date")(item.lastSent))
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: _vm.syncStatusIcons[item.status].color,
                                flat: "",
                                round: "",
                                icon: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$syncService.sync(item)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("sync")])],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  index + 1 < _vm.$syncService.items.length
                    ? _c("v-divider")
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4260014b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4260014b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sync.vue
// module id = zLGT
// module chunks = 1